import React, { useEffect, useState, memo } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import './style.scss';
import ToggleButton from '../../Images/sidebar/ToggleButton.svg';
import LogoMetaModel from '../../Images/sidebar/MetaModels_Logo.svg';
import { Link } from 'react-router-dom';
import Button from '../Button/Button';
import MyImageIcon from '../../Images/sidebar/MyImagesIcon.svg';
import ShowcaseIcon from '../../Images/sidebar/ShowcaseIcon.svg';
import CreditIcon from '../../Images/sidebar/CreditIcon.svg';
import PricingIcon from '../../Images/sidebar/PricingIcon.svg';
import ContactUsIcon from '../../Images/sidebar/ContactUsIcon.svg';
import HelpIcon from '../../Images/sidebar/HelpIcon.svg';
import UserSettingIcon from '../../Images/sidebar/UserSettingIcon.svg';
import LogoutIcon from '../../Images/sidebar/LogoutIcon.svg';
import MetaModelLogoSmall from '../../Images/sidebar/SmallMetaModelLogo.svg';
import DashboardActiveIcon from '../../Images/sidebar/activeIcons/DashboardActiveIcon.svg';
import DashboardIcon from '../../Images/sidebar/DashboardIcon.svg';
import DigitalModelIcon from '../../Images/sidebar/DigitalModelIcon.svg';
import useLogout from '../../hooks/useLogout';
import useAuthContext from '../../hooks/useAuthContext';
import { LoginButton } from '../Button/Button';
import useCreditContext from '../../hooks/useCreditContext';
import ContactUsActive from '../../Images/sidebar/activeIcons/ContactUsActive.svg';
import HelpActive from '../../Images/sidebar/activeIcons/HelpActive.svg';
import MyImageActiveIcon from '../../Images/sidebar/activeIcons/MyImagesActiveIcon.svg';
import PricingActive from '../../Images/sidebar/activeIcons/PricingActive.svg';
import ShowCaseActive from '../../Images/sidebar/activeIcons/ShowCaseActive.svg';
import UserSettingActive from '../../Images/sidebar/activeIcons/UserSettingActive.svg';
import CreditActive from '../../Images/sidebar/activeIcons/CreditActive.svg';
import { resetForStepWiseUserData } from '../../redux/Reducers/userStepsDataDetailReducer';
import { useDispatch } from 'react-redux';
import { Tooltip } from 'antd';
import GoogleCalendarButton from '../../component/GoogleCalendarButton';

const Sidebar = ({ handleToggle }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const leadIdFromUrl = searchParams.get('leadId');
    const persistedLeadId = localStorage.getItem('leadId');

    if (leadIdFromUrl !== null && leadIdFromUrl !== 'null') {
      localStorage.setItem('leadId', leadIdFromUrl);
    } else if (!persistedLeadId) {
      console.log('No leadId found in URL or localStorage.');
    }
  }, [searchParams]);

 

  const {
    credits: { free: freeCredits, paid: paidCredits },
    refetchCredits,
  } = useCreditContext();

  const {
    user: { userEmail },
    isAuthenticated,
  } = useAuthContext();

  useEffect(() => {
    !!isAuthenticated  && refetchCredits();
  }, []);

  const initialLowerSideBarContent = [
    { id: 1, type: 'break', isAuthenticated: false },
    {
      id: 2,
      type: 'link',
      text: 'Credit',
      isAuthenticated: true,
      isActive: false,
      // path: '/user-setting?from=credit',
      defaultIcon: CreditIcon,
      activeIcon: CreditActive,
    },
    {
      id: 3,
      type: 'link',
      text: 'Pricing',
      isAuthenticated: false,
      isActive: false,
      path: '/subscription',
      defaultIcon: PricingIcon,
      activeIcon: PricingActive,
    },
    // { id: 4, type: 'break', isAuthenticated: false },
    // {
    //   id: 5,
    //   type: 'link',
    //   text: 'Contact Us',
    //   isAuthenticated: false,
    //   isActive: false,
    //   path: '/contact',
    //   defaultIcon: ContactUsIcon,
    //   activeIcon: ContactUsActive,
    // },
    // {
    //   id: 6,
    //   type: 'link',
    //   text: 'Help & Support',
    //   isAuthenticated: false,
    //   isActive: false,
    //   path: '/help',
    //   defaultIcon: HelpIcon,
    //   activeIcon: HelpActive,
    // },
    // { id: 7, type: 'break', isAuthenticated: false },
    // {
    //   id: 8,
    //   type: 'link',
    //   text: 'User Setting',
    //   isAuthenticated: true,
    //   isActive: false,
    //   path: '/user-setting',
    //   defaultIcon: UserSettingIcon,
    //   activeIcon: UserSettingActive,
    // },
    {
      id: 9,
      type: 'handleAuthentication',
      text: 'Login/Logout',
      isAuthenticated: false,
      isActive: false,
      path: '/help',
    },
  ];

  const initialUpperSideBarContent = [
   
    // {
    //   id: 5,
    //   type: 'link',
    //   text: 'Upload Images',
    //   isAuthenticated: false,
    //   isActive: false,
    //   path: '/upload-images',
    //   defaultIcon: DigitalModelIcon,
    //   activeIcon: DigitalModelIcon,
    // },
    
    {
      id: 3,
      type: 'link',
      text: 'Dashboard',
      isAuthenticated: true,
      isActive: false,
      path: '/dashboard',
      defaultIcon: DashboardIcon,
      activeIcon: DashboardActiveIcon,
    },
    
    
  ];
  const [lowerSideBarContent, setLowerSideBarContent] = useState(
    initialLowerSideBarContent
  );
  const [upperSideBarContent, setUpperSideBarContent] = useState(
    initialUpperSideBarContent
  );

  useEffect(() => {
    const filterUnauthenticated = (content) => {
      return content.filter((item) => !item.isAuthenticated);
    };

    const updateActiveStatus = (content) => {
      return content.map((item) => {
        let isActive;
        if (item.text === 'Credit') {
          isActive =
            location.pathname === '/user-setting' &&
            searchParams.get('from') === 'credit';
        } else if (item.text === 'User Setting') {
          isActive =
            location.pathname === '/user-setting' && !searchParams.get('from');
        } else {
          isActive = location.pathname === item.path;
        }
        return {
          ...item,
          isActive,
        };
      });
    };

    if (!userEmail && !isAuthenticated) {
      setLowerSideBarContent(filterUnauthenticated(initialLowerSideBarContent));
      setUpperSideBarContent(filterUnauthenticated(initialUpperSideBarContent));
    } else {
      setLowerSideBarContent(initialLowerSideBarContent);
      setUpperSideBarContent(initialUpperSideBarContent);
    }
    setLowerSideBarContent((prevContent) => updateActiveStatus(prevContent));
    setUpperSideBarContent((prevContent) => updateActiveStatus(prevContent));
  }, [userEmail, isAuthenticated, location, searchParams]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 600 && window.innerWidth <= 700) {
        setSidebarToggle(true);
      } else {
        setSidebarToggle(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

 

  const handleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
    handleToggle();
  };

  const handleLogout = () => {
    logout();
    dispatch(resetForStepWiseUserData({}));
  };

  const getMetaModelLogo = () => {
    return !sidebarToggle ? (
      <div className="logo-main">
        <Link to="https://www.metamodels.ai/" target="_blank">
          <img
            src={LogoMetaModel}
            alt="logo_metamodel"
            className="logo_metamodel"
          />
        </Link>
      </div>
    ) : (
      <div className="small_logo-main">
        <Link to="https://www.metamodels.ai/" target="_blank">
          <img
            src={MetaModelLogoSmall}
            alt="logo_metamodel"
            className="logo_metamodel_small"
          />
        </Link>
      </div>
    );
  };

  // const getToggleButton = () => {
  //   return (
  //     <div
  //       onClick={handleSidebar}
  //       className={`toggle_sidebar_button ${
  //         sidebarToggle ? 'small_toggle_sidebar' : ''
  //       }`}
  //     >
  //       <img
  //         src={ToggleButton}
  //         alt="sidebarButton"
  //         className={`toggle_image ${!sidebarToggle ? 'rotate' : ''}`}
  //       />
  //     </div>
  //   );
  // };

  const getSideBarContent = () => {
    return (
      <div className="sidebar_content">
        <div className="upper_section">
          <Button
            text="Create Request"
            width={'100%'}
            height={'40px'}
            handleClick={() => navigate('/')}
          />

          {upperSideBarContent.map((content, index) => {
            return (
              <Link
                key={index}
                to={content.path}
                className={`${content.isActive ? 'active-link' : ''}`}
              >
                <img
                  src={
                    content.isActive ? content.activeIcon : content.defaultIcon
                  }
                  alt="showcase-icon"
                />{' '}
                {content.text}
              </Link>
            );
          })}
        </div>

        <div className="lower_section">
          {lowerSideBarContent.map((content, index) => {
            return content.type === 'break' ? (
              <div key={index} className="break" />
            ) : content.type === 'link' ? (
              <div key={index} className="link">
                <Link
                  to={content.path}
                  className={`${content.isActive ? 'active-link' : ''}`}
                >
                  <img
                    src={
                      content.isActive
                        ? content.activeIcon
                        : content.defaultIcon
                    }
                    alt={content.text}
                  />
                  {content.text}{' '}
                  {content.text === 'Credit'
                    ? ': ' + Number((freeCredits ?? 0) + (paidCredits ?? 0))
                    : ''}
                </Link>
              </div>
            ) : content.type === 'handleAuthentication' ? (
              isAuthenticated ? (
                <div key={index} className="link">
                  <Link onClick={handleLogout}>
                    <img src={LogoutIcon} alt="logout" />
                    Logout
                  </Link>
                </div>
              ) : (
                <div key={index} className="loginBtn">
                  <LoginButton
                    height="40px"
                    width="140px"
                    text="Login"
                    handleClick={() => navigate('/login')}
                  />
                </div>
              )
            ) : (
              ''
            );
          })}
          {/* <GoogleCalendarButton calendar={`calendar-button`} /> */}
        </div>
      </div>
    );
  };

  const getSmallSideBarContent = () => {
    return (
      <div className="small_sidebar_content">
        <div className="upper_section">
          <Button
            text="+"
            width={'40px'}
            height={'40px'}
            fontSize={'20px'}
            handleClick={() => navigate('/')}
            toolTipPlacement={'right'}
            toolTipText={'Create New Image'}
          />
          {upperSideBarContent.map((content, index) => {
            return (
              <Link
                key={index}
                to={content.path}
                className={`${content.isActive ? 'active-link' : ''}`}
              >
                <Tooltip title={content.text} placement="rightTop">
                  <img
                    src={
                      content.isActive
                        ? content.activeIcon
                        : content.defaultIcon
                    }
                    alt={content.text}
                  />{' '}
                </Tooltip>
              </Link>
            );
          })}
        </div>
        <div className="lower_section">
          {lowerSideBarContent.map((content, index) => {
            return content.type === 'break' ? (
              <div key={index} className="break" />
            ) : content.type === 'link' ? (
              <div key={index} className="link">
                <Link
                  to={content.path}
                  className={`${content.isActive ? 'active-link' : ''}`}
                >
                  <Tooltip title={content.text} placement="rightTop">
                    <img
                      src={
                        content.isActive
                          ? content.activeIcon
                          : content.defaultIcon
                      }
                      alt="showcase-icon"
                    />{' '}
                  </Tooltip>
                </Link>
              </div>
            ) : content.type === 'handleAuthentication' ? (
              isAuthenticated ? (
                <div key={index} className="link">
                  <Link onClick={handleLogout}>
                    <Tooltip title={`Logout`} placement="rightTop">
                      <img src={LogoutIcon} alt="logout" />
                    </Tooltip>
                  </Link>
                </div>
              ) : (
                <div key={index} className="loginBtn"></div>
              )
            ) : (
              ''
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="sidebar-main">
      <div className="content">
        {/* {getMetaModelLogo()} */}
        {/* {getToggleButton()} */}
        {!sidebarToggle ? getSideBarContent() : getSmallSideBarContent()}
      </div>
    </div>
  );
};

export default memo(Sidebar);
